import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig/authConfig";

// Single shared MSAL instance. Lives in its own module (not index.js) so
// utility code (e.g. getActiveDirectoryAuthToken.js) can import it without
// creating a circular dependency back through the app's entry point.
export const msalInstance = new PublicClientApplication(msalConfig);
